import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class AccountBillingDetailsService {
    static getAccountBillingSummary(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'), 'getAccountBillingSummary_Ext', [], authHeader);
    }

    static getAccountInvoiceStreamInformation(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getAccountInvoiceStreamInformation', [], authHeader);
    }

    static getInvoiceStreamDetails(invoiceStreamId, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'), 'getInvoiceStreamDetails_Ext', [invoiceStreamId], authHeader);
    }

    static setPaymentGroupPaymentInformation(invoiceStreamId, instrument, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'setPaymentGroupPaymentInformation', [invoiceStreamId, instrument], authHeader);
    }

    static makeDirectBillPayment(invoiceIds, amount, instrument, authHeader = {}) {
        const directBillPaymentDto = {
            invoiceIds,
            amountPaid: amount,
            paymentInstrument: instrument
        };
        return JsonRPCService.send(getProxiedServiceUrl('directBillPayment'),
            'makeDirectBillPayment', [directBillPaymentDto], authHeader);
    }

    static getInvoiceDeliveryMethods(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getInvoiceDeliveryMethods', [], authHeader);
    }

    static setInvoiceDeliveryMethodForAccount(newDeliveryMethod, accountNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'setInvoiceDeliveryMethodForAccount', [newDeliveryMethod, accountNumber], authHeader);
    }

    static getCreditCardFee(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingPayment'), 'getCreditCardFee', [data], additionalHeaders);
    }

    static getAuthNetHostedPaymentPageToken(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingPayment'), 'getAuthNetHostedPaymentPageToken', [data], additionalHeaders);
    }

    // NEW ONE INC METHODS

    static sessionIDOneInc(authHeader) {
        return JsonRPCService.send(getProxiedServiceUrl('billingPayment'), 'sessionIDOneInc', [], authHeader);
    }

    static custumerIDOneInc(contact, authHeader) {
        return JsonRPCService.send(getProxiedServiceUrl('billingPayment'), 'custumerIDOneInc', [contact], authHeader);
    }

    // PSF state method


    static getNonPSFStates(authHeader) {
        return JsonRPCService.send(getProxiedServiceUrl('billingPayment'), 'getNonPSFStates', [], authHeader);
    }


    static changePaymentPlanAndCreateInstrument(params, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'changePaymentPlanAndCreateInstrument', [params], authHeader);
    }

    static changePaymentMethod(policyNumber, params, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'changePaymentMethod', [policyNumber, params], authHeader);
    }

    static getPolicyPaymentPlan(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'getPolicyPaymentPlan', [policyNumber], authHeader);
    }

    static getPaymentInstrument(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'getPaymentInstrument', [policyNumber], authHeader);
    }

    static getAccountInvoiceStreamInformationExt(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'), 'getAccountInvoiceStreamInformation_Ext', [], authHeader);
    }

    static getCompletedInvoicesForPayment(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'), 'getCompletedInvoicesForPayment', [], authHeader);
    }

    static isHaveCancelledPolicyWithDueInvoice(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'), 'isHaveCancelledPolicyWithDueInvoice', [], additionalHeaders);
    }

    static getEmailAddress(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'getEmailAddress', [policyNumber], authHeader);
    }

    static setEmailAddress(policyNumber, email, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDataExt'),
            'setEmailAddress', [policyNumber, email], authHeader);
    }
}
